import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import { Grid, Typography } from "@mui/material";
import { memo, useCallback } from "react";
import CloseIconButton from "@entrilia/shared/components/CloseIconButton.tsx";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill.tsx";
import { ValidationItemContainer } from "../../../../reporting/report-lists/reports/copyto/CompanyMultipleReportsListItemContainer.tsx";
import { ReportInProgress } from "../../../../reporting/report-lists/reports/copyto/controls/ReportInProgress.tsx";
import { WaitingForValidation } from "../../../../reporting/report-lists/reports/copyto/controls/WaitingForValidation.tsx";
import type { SelectedCompanyTile } from "../../../hooks/validationStateSlice.ts";
import type { DashboardValidationType } from "../../hooks/useDashboardValidation.ts";

interface Props {
  tile: SelectedCompanyTile;
  validation: DashboardValidationType;
}

const ValidatedStatus = memo(function ValidatedStatus({ tile }: { tile: SelectedCompanyTile }) {
  return (
    <Grid container sx={{ gap: 0.8, flexWrap: "nowrap", alignItems: "center", width: "100%" }}>
      <Typography variant="caption" color="secondary">
        {tile.tile.widget.type}
      </Typography>
      <HorizontalFill />
      <Typography sx={{ color: "success.main" }}>{"Can be copied"}</Typography>
      <CheckRoundedIcon color="success" />
    </Grid>
  );
});

export const ArbitraryTileItemValidation = ({ tile, validation }: Props) => {
  const active =
    tile.companyCode === validation.activeCompanyTile?.companyCode &&
    validation.activeCompanyTile?.tile.tileId === tile.tile.tileId;
  const onSelected = useCallback(() => {
    validation.setActiveCompanyTile(tile);
  }, [validation, tile]);

  const onRemove = useCallback(() => {
    validation.removeTile(tile);
  }, [validation, tile]);

  return (
    <ValidationItemContainer
      caption={tile.tile.widget.nameUserInput || "(No name)"}
      active={active}
      completed={tile.validated}
      selectable
      onSelected={onSelected}
      TopAction={<CloseIconButton onClick={onRemove} color="secondary" size="small" />}
    >
      {!tile.validating && !tile.validated && !tile.error && <WaitingForValidation />}
      {tile.validating && <ReportInProgress text={"Validating..."} />}
      {tile.validated && <ValidatedStatus tile={tile} />}
    </ValidationItemContainer>
  );
};
